import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
    Home,
    BarChart2,
    Car,
    ClipboardList,
    PhoneCall,
    FileText,
    Wrench,
    LogOut,
} from "lucide-react";
import { useDispatch } from "react-redux";

import { onLogout } from "../../Auth/Actions"

const Sidebar = () => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(true);
    const navigate = useNavigate();

    const handleLogout = () => {
        dispatch(onLogout())
        localStorage.clear();  // remove tokens etc.
        navigate("/admin");
    };

    const sidebarStyle = {
        width: open ? "240px" : "70px",
        height: "100vh",
        transition: "0.3s",
        background: "#000",
        color: "#fff",
        position: "fixed",
        left: 0,
        top: 0,
        overflow: "hidden",
        boxShadow: "2px 0 10px rgba(0,0,0,0.2)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    };

    const headerStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: open ? "space-between" : "center",
        padding: "10px 5px",
        borderBottom: "1px solid #1f2937",
    };

    const toggleBtnStyle = {
        background: "transparent",
        border: "none",
        color: "#fff",
        cursor: "pointer",
        fontSize: "18px",
        padding: "8px",
    };

    const menuItemStyle = {
        display: "flex",
        alignItems: "center",
        padding: "12px 15px",
        color: "#fff",
        textDecoration: "none",
        cursor: "pointer",
        transition: "0.2s",
    };

    const activeStyle = {
        background: "#1f2937",
        borderLeft: "4px solid #3b82f6",
    };

    const iconStyle = {
        minWidth: "22px",
    };

    const labelStyle = {
        opacity: open ? 1 : 0,
        marginLeft: "15px",
        transition: "0.2s",
        whiteSpace: "nowrap",
    };

    const menu = [
        { label: "Dashboard", path: "/dashboard", icon: <Home style={iconStyle} /> },
        { label: "Advertisement", path: "/advertisement", icon: <BarChart2 style={iconStyle} /> },
        { label: "Test Drive", path: "/book-test-drive", icon: <PhoneCall style={iconStyle} /> },
        { label: "Contact Details", path: "/contact-details", icon: <PhoneCall style={iconStyle} /> },
        { label: "Service Request", path: "/service-request", icon: <Wrench style={iconStyle} /> },
        { label: "Vehicle Enquiry", path: "/vehicle-enquiry", icon: <Car style={iconStyle} /> },
        { label: "Enquiry", path: "/enquiry", icon: <ClipboardList style={iconStyle} /> },
        { label: "Quotation", path: "/quatation", icon: <FileText style={iconStyle} /> },
        { label: "Old Cars", path: "/oldcar", icon: <Car style={iconStyle} /> },
    ];

    return (
        <div style={sidebarStyle}>

            {/* Header */}
            <div>
                <div style={headerStyle}>
                    <a
                        href="/profile"
                        style={{ textDecoration: "none", color: "inherit" }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                transition: "0.3s",
                                cursor: "pointer",
                            }}
                        >
                            <img
                                src="/logo192.png"
                                alt="Profile"
                                style={{
                                    width: "40px",
                                    height: "40px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                }}
                            />

                            {open && (
                                <div>
                                    <div style={{ fontSize: "15px", fontWeight: "600" }}>
                                        Central Kia
                                    </div>
                                    <div
                                        style={{
                                            fontSize: "12px",
                                            opacity: "0.7",
                                            marginTop: "2px",
                                        }}
                                    >
                                        Admin
                                    </div>
                                </div>
                            )}
                        </div>
                    </a>
                    <button onClick={() => setOpen(!open)} style={toggleBtnStyle}>
                        {open ? "◀" : "▶"}
                    </button>
                </div>



                {/* Menu */}
                {menu.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        style={({ isActive }) => ({
                            ...menuItemStyle,
                            ...(isActive ? activeStyle : {}),
                        })}
                    >
                        {item.icon}
                        <span style={labelStyle}>{item.label}</span>
                    </NavLink>
                ))}
            </div>

            {/* Logout */}
            <div
                onClick={handleLogout}
                style={{
                    ...menuItemStyle,
                    borderTop: "1px solid #1f2937",
                    marginBottom: "10px",
                }}
            >
                <LogOut style={iconStyle} />
                <span style={labelStyle}>Logout</span>
            </div>
        </div>
    );
};

export default Sidebar;
